import React, { useState } from "react";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import Typography from "../../components/Typography";
import FilterTag from "../../components/FilterTag/FilterTag";
import InputSearch from "../InputSearch/InputSearch";

import GOOGLEGBM from "../../build/images/googlegbm-new.svg";
import { ReactComponent as IconArrowDown } from "../../build/images/icons/arrow-down.svg";
import { ReactComponent as IconArrowDownV2 } from "../../build/images/icons/arrow-down-v2.svg";
import { ReactComponent as WHATSAPPICON } from "../../build/new-midias-icons/whatsapp.svg";
import { ReactComponent as WHATSAPPVOICEICON } from "../../build/new-midias-icons/whatsapp-voz.svg";
import { ReactComponent as FACEBOOKICON } from "../../build/new-midias-icons/facebook.svg";
import { ReactComponent as INSTAGRAM } from "../../build/new-midias-icons/instagram.svg";
import { ReactComponent as VOZICON } from "../../build/new-midias-icons/voz.svg";
import { ReactComponent as EMAILICON } from "../../build/new-midias-icons/email.svg";
import { ReactComponent as TELEGRAMICON } from "../../build/new-midias-icons/telegram.svg";
import { ReactComponent as TWITTERICON } from "../../build/new-midias-icons/twitter.svg";
import { ReactComponent as LINKEDINICON } from "../../build/new-midias-icons/linkedin.svg";
import { ReactComponent as WEBCHATICON } from "../../build/new-midias-icons/webchat.svg";
import { ReactComponent as SMSICON } from "../../build/new-midias-icons/sms-icon.svg";
import { ReactComponent as TEAMSICON } from "../../build/new-midias-icons/teams.svg";

import "./select-tag.css";

const getMediaIcon = (mediaId) => {
  switch (mediaId) {
    case 1:
      return <VOZICON />;
    case 2:
      return <WEBCHATICON />;
    case 3:
      return <EMAILICON />;
    case 4:
      return <FACEBOOKICON />;
    case 5:
      return <WHATSAPPICON />;
    case 6:
      return <INSTAGRAM />;
    case 8:
      return <TELEGRAMICON />;
    case 9:
      return <TWITTERICON />;
    case 10:
      return <LINKEDINICON />;
    case 11:
      return <img src={GOOGLEGBM} alt="Google GBM" width={24} height={24} />;
    case 12:
      return <SMSICON />;
    case 15:
      return <TEAMSICON />;
    case 16:
      return <WHATSAPPVOICEICON />;
    default:
      return "-";
  }
};

export default function SelectTagV2({
  valueTag,
  priority = false,
  channel = false,
  options = [
    {
      id: 1,
      label: "Option1",
    },
    {
      id: 2,
      label: "Option2",
    },
    {
      id: 3,
      label: "Option3",
    },
  ],
  onSelect,
  onKeyDown,
  placeholder,
  multiple = true,
  isCallCenter = false,
  isChipActive = true,
  isCloseOnSelect = true,
}) {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const priorityOptions = [
    {
      id: 3,
      label: "Baixa",
    },
    {
      id: 2,
      label: "Média",
    },
    {
      id: 1,
      label: "Alta",
    },
    {
      id: 4,
      label: "Crítica",
    },
  ];

  const [open, setOpen] = useState(false);
  const [inputSearch, setInputSearch] = useState("");

  function renderSelectedOption(value) {
    const isMultiple = multiple;
    if (isMultiple) {
      return (
        <FilterTag
          label={value.label || value.name}
          channelIcon={channel ? getMediaIcon(value.id) : false}
          onClose={(e) => {
            onSelect(value);
            e.stopPropagation();
          }}
        />
      );
    }

    if (isChipActive) {
      return (
        <FilterTag
          label={value.label || value.name}
          channelIcon={channel ? getMediaIcon(value.id) : false}
          onClose={(e) => {
            onSelect(value);
            e.stopPropagation();
          }}
        />
      );
    }

    return <span>{value.label || value.name}</span>;
  }

  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleValuePriority = (value) => {
    switch (value) {
      case "Baixa":
        return 3;

      case "Média":
        return 2;

      case "Alta":
        return 1;

      case "Crítica":
        return 4;

      default:
        break;
    }
  };

  const listFilter = (item) => {
    if (inputSearch) {
      if (item.label.toLowerCase().includes(inputSearch.toLowerCase())) {
        return item;
      } else {
        return;
      }
    } else {
      return item;
    }
  };

  const renderItems = () => {
    return (
      <div>
        {options.filter(listFilter).map((option, index) => (
          <div key={`${option.label}-${index}`}>
            <div
              value={option.label}
              onClick={() => {
                onSelect(option);
                if (isCloseOnSelect) {
                  handleOpen();
                }
              }}
              className={`menu-item ${
                valueTag && valueTag.find((vlue) => vlue.id === option.id)
                  ? "active"
                  : ""
              }`}
            >
              <Typography.H5 weight={"500"} color="gray-400">
                {channel && getMediaIcon(option.id)}
                {option.label}
              </Typography.H5>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div>
      <FormControl
        sx={
          isCallCenter
            ? {
                width: "100%",
                height: 40,
                "& .MuiBox-root": {
                  display: "flex",
                  alignItems: "center",
                  height: "40px",
                  paddingLeft: "10px",
                },
                "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input":
                  {
                    padding: "0px",
                  },
              }
            : { width: "100%", minHeight: 40 }
        }
      >
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          open={open}
          onClose={handleOpen}
          multiple={multiple}
          className={`select-tag-ingweb ${
            isCallCenter ? "select-tag-ingweb--cal-center" : ""
          }`}
          displayEmpty
          value={
            multiple
              ? Array.isArray(valueTag)
                ? valueTag
                : []
              : valueTag || ""
          }
          input={<OutlinedInput id="select-multiple-chip" />}
          onKeyDown={onKeyDown}
          renderValue={(selected) => {
            return (
              <Box
                onClick={() => handleOpen()}
                sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
              >
                <ul className="multiple-chip-list">
                  {selected.length === 0 ? (
                    <Typography.H5 weight={400} color="gray-125">
                      {placeholder ? placeholder : "Selecione"}
                    </Typography.H5>
                  ) : (
                    selected.map((value) => {
                      const priorityValue = priority
                        ? handleValuePriority(value.label)
                        : "";

                      return (
                        <li key={value.id}>
                          {/* {value.label || value.name} */}
                          {renderSelectedOption(value)}
                        </li>
                      );
                    })
                  )}
                </ul>
              </Box>
            );
          }}
          IconComponent={isCallCenter ? IconArrowDownV2 : IconArrowDown}
          MenuProps={MenuProps}
        >
          <InputSearch
            search={inputSearch}
            setSearch={setInputSearch}
            // handleClick={(e) => handleSearch(searchData)}
            onSearch={(e) => setInputSearch(inputSearch)}
            onKeyDown={true}
          />
          {renderItems()}
        </Select>
      </FormControl>
    </div>
  );
}
